import { useEffect } from 'react';

export interface IPortalLoadingProps {
  /**
   * @default true
   */
  isOverlayTransparent?: boolean;
  /**
   * Delay after which child component will be shown
   */
  delay?: number;
  /**
   * Text next to the spinner
   *
   * @default "Loading"
   */
  loadingText?: string;
  /**
   * Indicates whether need to show text next to the spinner
   * @default true
   */
  showText?: boolean;
}

/**
 * Portal loading. Forbids to user to interact with the whole portal.
 * Wrapper around MVC implementation.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function PortalLoading(props?: IPortalLoadingProps) {
  useEffect(() => {
    !IS_TEST && !DEV_SERVER && $Portal.Progress.showLoadingIndicator({ delay: 1000, ...(props ?? {}) });

    return () => {
      !IS_TEST && !DEV_SERVER && $Portal.Progress.hideLoadingIndicator();
    };
  }, [props]);

  return null;
}
